const opts = {
  filterable: true,
  sortable: false
};
export default {
  id: 'recovr.vehicle.locatorPaired',
  name: 'vehicle.locatorPaired',
  displayName: 'Paired',
  valueType: 'boolean',
  objectType: 'vehicle',
  get: obj => {
    return obj?.data?.locator?.id != null;
  },
  getOption: key => {
    return opts[key] || null;
  },
  blueprint: {
    field: 'data/locator/id'
  }
};